export const IS_ADDED_TO_CART_SESSION_STORAGE_NAME = 'isAddedToCart';
